export default "__VITE_ASSET__CBAW8GWj__"